/**
 * Add-in entry point.
 * Initializes Office.js then renders the React app.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { App } from './App';
import './styles/global.css';

/* global Office */

Office.onReady((_info) => {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </React.StrictMode>
  );
});
